import { getStorefrontBasePath } from '../../modules/storefront/exports/Cookies';

class WindowResource {
  public basePath: string = getStorefrontBasePath() || '';

  public getBasePath(): string {
    return this.basePath;
  }
  public getOriginWithPathname(): string {
    return this.getOrigin() + window.location.pathname;
  }

  public getOrigin(): string {
    return window.location.origin + this.basePath;
  }

  /**
   * Compared with the base path in front: on a storefront the 404 page sits at `/speisekarte/404`, and
   * a bare `/404` check sent every unknown slug there into a reload loop.
   */
  public isNotFoundPage(): boolean {
    return window.location.pathname === `${this.basePath}/404`;
  }

  public replace(path: string): void {
    window.location.replace(this.basePath + path);
  }

  public setHref(href: string): void {
    window.location.href = this.basePath + href;
  }
}

export default new WindowResource();
